import React, { useState, useEffect } from 'react';
import '../styles/AvailableTowers.css';

const AvailableTowers = () => {
  const [towerData, setTowerData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTowerData = async () => {
      try {
        const response = await fetch('https://rangers-api-3mfw.onrender.com/api/guild-war-instructions-nihon/available-towers');
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || 'データの取得に失敗しました');
        }
        const data = await response.json();
        setTowerData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTowerData();
    // 5分ごとにデータを更新
    const interval = setInterval(fetchTowerData, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const getTowerTypeStyle = (buffLevel) => {
    if (buffLevel >= 3) return 'tower-type-boss';
    if (buffLevel >= 2) return 'tower-type-elite';
    return 'tower-type-normal';
  };

  const getAttackInstruction = (buffLevel, enemyUsers) => {
    if (!buffLevel) return 'なし';
    return `防衛配置者で攻撃（${buffLevel}負けまで）`;
  };

  const hasIndividualInstructions = (tower) => {
    return !tower.instructions.towerGroup && tower.instructions.attackers && tower.instructions.attackers.length > 0;
  };

  if (loading) {
    return (
      <div className="status-container">
        <div className="loading">
          <div className="loading-spinner"></div>
          <p>データを読み込み中...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="status-container">
        <div className="error-message">
          <h3>エラーが発生しました</h3>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!towerData || !towerData.towers || towerData.towers.length === 0) {
    return (
      <div className="status-container">
        <div className="no-data">
          <h3>攻撃可能な塔がありません</h3>
          <p>現在、攻撃可能な塔の情報はありません。</p>
          <p>しばらく待ってから再度確認してください。</p>
        </div>
      </div>
    );
  }

  return (
    <div className="available-towers">
      <h2>攻撃可能な塔（{towerData.battleNumber}戦目）</h2>
      <div className="tower-grid">
        {towerData.towers.map((tower) => (
          <div key={tower.number} className={`tower-card ${getTowerTypeStyle(tower.instructions.buffLevel)}`}>
            <div className="tower-header">
              <h3>Tower {tower.number}</h3>
            </div>
            <div className="tower-info">
              <div className="attack-info">
                <span className="label">バフ:</span>
                <span className="value">{getAttackInstruction(tower.instructions.buffLevel, tower.enemyUsers)}</span>
              </div>
              {!hasIndividualInstructions(tower) && (
                <div className="group-info">
                  <span className="label">攻撃者:</span>
                  <span className="value">{tower.instructions.towerGroup || "未設定"}</span>
                </div>
              )}
            </div>
            <div className="enemy-users">
              <h4>防衛評価</h4>
              {tower.enemyUsers.map((user, index) => (
                <div key={index} className="enemy-user">
                  <span className="user-name">{user.name}</span>
                  <div className="user-stats">
                    <span className="user-rating">{user.rating}</span>
                    {hasIndividualInstructions(tower) && tower.instructions.attackers[index] && (
                      <div className="individual-instruction">
                        <span className="attacker-group">{tower.instructions.attackers[index].group}</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AvailableTowers; 
